import Cookies from 'js-cookie'
const TokenKey = 'x-access-token'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}
export function setCompany(company) {
    return Cookies.set("company", company)
}

export function getCompany() {
    return Cookies.get("company")
}